// extracted by mini-css-extract-plugin
export default {"addButton":"OriginsPage_addButton__T6BMo"};